module.exports = __webpack_public_path__ + "media/images/payments/stripe_reminder-14d3b732bed1dd3a76c35d7d056ab5ae.png";